import React from 'react';
import { FileTextIcon, CheckIcon, XIcon } from 'lucide-react';
const pendingDocuments = [{
  id: 1,
  title: 'Contrato de Servicios #2024-123',
  type: 'Contrato',
  deadline: '2024-03-20'
}, {
  id: 2,
  title: 'Acuerdo de Confidencialidad',
  type: 'Legal',
  deadline: '2024-03-19'
}];
export const DocumentApproval = () => {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-464">
      <h2 className="text-lg font-semibold mb-4" data-id="element-465">Documentos Pendientes</h2>
      <div className="space-y-4" data-id="element-466">
        {pendingDocuments.map(doc => <div key={doc.id} className="p-4 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-467">
            <div className="flex items-start gap-3" data-id="element-468">
              <FileTextIcon className="h-5 w-5 text-blue-500 mt-1" data-id="element-469" />
              <div className="flex-1" data-id="element-470">
                <h3 className="font-medium text-gray-900" data-id="element-471">{doc.title}</h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-472">
                  {doc.type} • Vence: {doc.deadline}
                </p>
              </div>
              <div className="flex gap-2" data-id="element-473">
                <button className="p-1 text-green-600 hover:bg-green-50 rounded" data-id="element-474">
                  <CheckIcon className="h-5 w-5" data-id="element-475" />
                </button>
                <button className="p-1 text-red-600 hover:bg-red-50 rounded" data-id="element-476">
                  <XIcon className="h-5 w-5" data-id="element-477" />
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};